import {
	MergedStreakStat,
	StreakStat,
} from "@data-types/sport-stats/SportStatsTypes";
import { PromotionPhase } from "@data-types/sport-stats/SportStatsTypes";


export const mergeStreakStats = (items: StreakStat[]): MergedStreakStat[] => {
	const mergedStats: Record<string, MergedStreakStat> = {};

	items.forEach((item) => {
		const key = item.abrv;
		if (!mergedStats[key]) {
			mergedStats[key] = {
				...item,
				homeValue: item.team === "home" ? item.value : null,
				awayValue: item.team === "away" ? item.value : null,
			};
		} else {
			if (item.team === "home") mergedStats[key].homeValue = item.value;
			if (item.team === "away") mergedStats[key].awayValue = item.value;
		}
	});

	return Object.values(mergedStats);
};

export function getTeamStandingsPromotionClass(
	promotionPhase: PromotionPhase | undefined
): string {
	let phaseClass = "";

	switch (promotionPhase) {
		case PromotionPhase.Promotion:
			phaseClass = "playoffs-promotion-to-x-playoff";
			break;
		case PromotionPhase.Playoff:
			phaseClass = "playoffs-promotion-to-x";
			break;
		case PromotionPhase.Qualifying:
			phaseClass = "playoffs-promotion-to-y";
			break;
		case PromotionPhase.ConferenceQualification:
			phaseClass = "playoffs-promotion-to-z-playoff";
			break;
		case PromotionPhase.EuropaLeagueQualification:
			phaseClass = "playoffs-promotion-to-z-playoff-secondary";
			break;
		case PromotionPhase.RelegationPlayoffs:
			phaseClass = "playoffs-promotion-to-relegation-playoff";
			break;
		case PromotionPhase.Relegation:
			phaseClass = "playoffs-promotion-to-relegation";
			break;
		case PromotionPhase.None:
		default:
			phaseClass = "";
			break;
	}
	return phaseClass;
}
